import { Component, inject } from '@angular/core';
import { FeatureService } from '../../../../core/services/permission';

@Component({
    selector: 'app-contact-messages-view',
    templateUrl: './messages-view.component.html',
    standalone: false,
})
export class ContactMessagesViewComponent {
    canViewSms = inject(FeatureService).isAvailable('sms-features');
}
